module.exports = __webpack_public_path__ + "static/katika-logo-02d9707eaacd0901e12b79dd088a0621.png";